import React, {useContext} from "react";
import PropTypes from "prop-types";
import {View, Text} from "@react-pdf/renderer";

import {cartItemInterface} from "../../../shoppingCart/cartItemInterface";
import {getPriceWithCurrency} from "../../../../misc/helpers";
import {PrintDocumentContext} from "../printDocumentContext";
import {getCartItemName} from "../printDocumentFunctions";
import {getSimilarItemInfoObject} from "../../../shoppingCart/similarProducts/similarProductsFunctions";
import {featureCollectionInterface} from "../../../../interfaces/featureInterface";

const PrintSimilarProductsListItem = (props) => {

  const {styles, cartItem, addedCountertops, fabricatorData, locale, featureCollection, filterGroups, quoteIndex, lastItem,
    totalCountertopsQuantity} = props;
  const fabricatorSettings = fabricatorData.settings;
  const printContext = useContext(PrintDocumentContext);

  const {filterValueName, feature, subTotalPrice} = getSimilarItemInfoObject(
    cartItem,
    addedCountertops,
    featureCollection,
    totalCountertopsQuantity,
    quoteIndex,
    filterGroups
  );

  return (
    <View style={lastItem ? [styles.cartItemSimilarItem, styles.cartItemSimilarItemNoBorder] : styles.cartItemSimilarItem} wrap={false}>
      <View style={styles.cartItemSimilarItemBlock}>
        <Text style={styles.cartItemSimilarItemName}>
          {filterValueName}
        </Text>
        <Text style={styles.cartItemSimilarItemExample}>
          {printContext.messages["similar.product.example"]} {getCartItemName(feature, fabricatorData, printContext, locale)}
        </Text>
      </View>
      <View style={styles.cartItemSimilarItemBlock}>
        <Text style={styles.cartItemSimilarItemPrice}>{getPriceWithCurrency(fabricatorSettings, subTotalPrice, feature)}</Text>
      </View>
    </View>
  )
};

PrintSimilarProductsListItem.propTypes = {
  quoteIndex: PropTypes.number.isRequired,
  cartItem: PropTypes.shape(cartItemInterface),
  addedCountertops: PropTypes.arrayOf(PropTypes.shape(cartItemInterface)),
  featureCollection: PropTypes.shape(featureCollectionInterface),
  fabricatorData: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  filterGroups: PropTypes.array.isRequired,
  lastItem: PropTypes.bool.isRequired,
  styles: PropTypes.object.isRequired,
  totalCountertopsQuantity: PropTypes.number.isRequired,
};


export default PrintSimilarProductsListItem
